import { Btn, Input } from "@/components/shared";
import { Folder, FolderPlus } from "lucide-react";

export function FolderBar({ folders, folder, counts, total, onPick, onDropMove, canCreate, newFolder, setNewFolder, onCreate, hasSelection }) {
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="photo-folders">
      {["All", ...folders].map((f) => (
        <button key={f} data-testid={`folder-${f.replace(/\s+/g, "_")}`} onClick={() => onPick(f)}
          onDragOver={(e) => { if (f !== "All" && hasSelection) e.preventDefault(); }}
          onDrop={(e) => { if (f !== "All" && hasSelection) { e.preventDefault(); onDropMove(f); } }}
          className={`flex items-center gap-1.5 px-3 py-1.5 border-2 font-mono text-[11px] uppercase tracking-wide transition-colors ${folder === f ? "bg-[#FF5722] text-black border-black" : "border-zinc-800 text-zinc-400 hover:border-[#FF5722] hover:text-white"}`}>
          <Folder size={12} /> {f} <span className="opacity-70">{f === "All" ? total : counts[f] || 0}</span>
        </button>
      ))}
      {canCreate && (
        <div className="flex items-center gap-1 ml-auto">
          <Input data-testid="new-folder-input" value={newFolder} onChange={(e) => setNewFolder(e.target.value)} onKeyDown={(e) => e.key === "Enter" && onCreate()} placeholder="New folder…" className="h-8 w-36 text-xs" />
          <Btn variant="secondary" data-testid="new-folder-btn" onClick={onCreate} className="!px-2 !py-1.5"><FolderPlus size={14} /></Btn>
        </div>
      )}
    </div>
  );
}
